import { SitesetupConfiguration } from './../../sitesetup/config/sitesetup_configuration';
import { TransferCreditsProgressState } from '../progression/transfer_credits_progress_state';
import { Major } from '../builders/major_builder';
import { ICommand, IQuery } from 'core-ts-types';

angular.module('capability-ng-transfer').config(function($stateProvider: angular.ui.IStateProvider): void {
  $stateProvider
    .state('my.transfer', {
      abstract: true,
      url: 'transfer/',
      sticky: true,
      deepStateRedirect: {
        default: 'my.transfer.credits.major'
      },
      onEnter: function($timeout: ng.ITimeoutService, $state: angular.ui.IStateService): void {
        $timeout(function(): void {
          if ($state.current.name === 'my.transfer') {
            $state.go('my.transfer.credits.major');
          }
        });
      }
    } as any)

    .state('my.transfer.credits', {
      url: 'credits/',
      views: {
        'my@my': {
          templateUrl: 'lib/transfer/views/transfer_credits/transfer_credits.html',
          controller: 'ngTransferCreditsController',
          controllerAs: '$ctrl'
        },
        'right@my.transfer.credits': {
          templateUrl: 'lib/transfer/views/majors_overview/majors_overview.html',
          controller: 'ngTransferMajorsOverviewController',
          controllerAs: '$ctrl'
        }
      },
      data: {
        viewTitle: 'Transfer Credits'
      },
      resolve: {
        _cipProgramAreas: function(loadTransferCIPProgramAreasCommand: ICommand, _accessToken: ng.IPromise<never>) {
          return loadTransferCIPProgramAreasCommand();
        },
        _transferMajors: function(loadTransferCategoryMajorsCommand: ICommand, _accessToken: ng.IPromise<never>) {
          return loadTransferCategoryMajorsCommand();
        },
        _transferExamType: function(loadTransferExamTypeCommand: ICommand, _accessToken: ng.IPromise<never>) {
          return loadTransferExamTypeCommand();
        },
        _transferTermType: function(loadTransferTermTypeCommand: ICommand, _accessToken: ng.IPromise<never>) {
          return loadTransferTermTypeCommand();
        },
        _transferGrade: function(loadTransferGradeCommand: ICommand, _accessToken: ng.IPromise<never>) {
          return loadTransferGradeCommand();
        }
      },
      onEnter: function(
        $timeout: ng.ITimeoutService,
        $state: angular.ui.IStateService,
        ngTransferCreditsProgressState: TransferCreditsProgressState
      ): void {
        $timeout(function(): void {
          if ($state.current.name === 'my.transfer.credits') {
            const lastVisitedState = ngTransferCreditsProgressState.getLastVisitedState();
            $state.go(`my.transfer.credits.${lastVisitedState}`);
          }
        });
      }
    })

    .state('my.transfer.credits.major', {
      url: 'major/',
      views: {
        'left@my.transfer.credits': {
          templateUrl: 'lib/transfer/views/choose_major/choose_major.html',
          controller: 'ngTransferCreditsChooseMajorController',
          controllerAs: '$ctrl'
        }
      },
      onEnter: (
        ngTransferCreditsProgressState: TransferCreditsProgressState,
        updateTransferProgressCommand: ICommand
      ): void => {
        if (ngTransferCreditsProgressState.getLastVisitedState() !== 'major') {
          updateTransferProgressCommand('major');
        }
      },
      data: {
        viewTitle: 'Choose a major'
      }
    })

    .state('my.transfer.credits.past', {
      url: 'past/',
      views: {
        'left@my.transfer.credits': {
          templateUrl: 'lib/transfer/views/past_courses/past_courses.html',
          controller: 'ngTransferCreditsPastCoursesController',
          controllerAs: '$ctrl'
        }
      },
      onEnter: (
        ngTransferCreditsProgressState: TransferCreditsProgressState,
        updateTransferProgressCommand: ICommand
      ): void => {
        if (ngTransferCreditsProgressState.getLastVisitedState() !== 'past') {
          updateTransferProgressCommand('past');
        }
      },
      data: {
        viewTitle: 'Colleges and courses'
      }
    })

    .state('my.transfer.credits.exam', {
      url: 'exam/',
      views: {
        'left@my.transfer.credits': {
          templateUrl: 'lib/transfer/views/exam_credits/exam_credits.html',
          controller: 'ngTransferExamCreditsController',
          controllerAs: '$ctrl'
        }
      },
      onEnter: (
        ngTransferCreditsProgressState: TransferCreditsProgressState,
        updateTransferProgressCommand: ICommand
      ): void => {
        if (ngTransferCreditsProgressState.getLastVisitedState() !== 'exam') {
          updateTransferProgressCommand('exam');
        }
      },
      data: {
        viewTitle: 'Other Credits'
      }
    })

    .state('my.transfer.credits.refine', {
      url: 'refine/',
      views: {
        'left@my.transfer.credits': {
          templateUrl: 'lib/transfer/views/refine_estimate/refine_estimate.html',
          controller: 'ngTransferCreditsRefineEstimateController',
          controllerAs: '$ctrl'
        }
      },
      onEnter: (
        ngTransferCreditsProgressState: TransferCreditsProgressState,
        updateTransferProgressCommand: ICommand
      ): void => {
        if (ngTransferCreditsProgressState.getLastVisitedState() !== 'refine') {
          updateTransferProgressCommand('refine');
        }
      },
      resolve: {
        shouldAllowToProceed: (
          _config: any,
          ngSitesetupConfiguration: SitesetupConfiguration,
          $state: ng.ui.IStateService,
          $q: ng.IQService,
          $timeout: ng.ITimeoutService
        ) => {
          const deferred = $q.defer();
          $timeout(() => {
            if (!ngSitesetupConfiguration.isAdditionalCourseInfoEnabled) {
              $state.go('oops');
              deferred.reject();
            }
            deferred.resolve();
          }, 10);
          return deferred.promise;
        }
      },
      data: {
        viewTitle: 'Refine Estimate'
      }
    })

    .state('my.transfer.credits.summary', {
      url: 'summary/',
      views: {
        'left@my.transfer.credits': {
          templateUrl: 'lib/transfer/views/credits_summary/credits_summary.html',
          controller: 'ngTransferCreditsSummaryController',
          controllerAs: '$ctrl'
        }
      },
      onEnter: (
        ngTransferCreditsProgressState: TransferCreditsProgressState,
        updateTransferProgressCommand: ICommand
      ): void => {
        if (ngTransferCreditsProgressState.getLastVisitedState() !== 'summary') {
          updateTransferProgressCommand('summary');
        }
      },
      data: {
        viewTitle: 'Summary'
      }
    })

    .state('my.transfer.major_details', {
      url: 'major-details/:majorId/',
      views: {
        'my@my': {
          templateUrl: 'lib/transfer/views/major_details/major_details.html',
          controller: 'ngTransferMajorDetailsController',
          controllerAs: '$ctrl'
        }
      },
      resolve: {
        _transferMajors: function(loadTransferCategoryMajorsCommand: ICommand, _accessToken: ng.IPromise<never>) {
          return loadTransferCategoryMajorsCommand();
        },
        _transferStudent: function(
          loadTransferStudentCommand: ICommand,
          _accessToken: ng.IPromise<never>,
          _transferMajors: ng.IPromise<IQuery[]>
        ) {
          return loadTransferStudentCommand();
        },
        major: function(
          loadTransferMajorDetailsCommand: ICommand,
          $stateParams: ng.ui.IStateProvider,
          _accessToken: ng.IPromise<never>
        ): ng.IPromise<Major> {
          return loadTransferMajorDetailsCommand($stateParams['majorId']);
        }
      },
      data: {
        viewTitle: 'Transfer Major Detail'
      }
    });
});



// WEBPACK FOOTER //
// ./app/lib/transfer/config/route_configuration.ts